// src/components/appointments/InvoicePanel.js
import React from 'react';
import { useTranslations } from '../../hooks/useTranslations';

const InvoicePanel = ({ appointment }) => {
  const t = useTranslations();

  const handleDownloadInvoice = () => {
    if (appointment.invoice_url) {
      window.open(appointment.invoice_url, '_blank', 'noopener,noreferrer');
    }
  };

  const formatInvoiceAmount = () => {
    const amount = appointment.payment_amount || appointment.price;
    return `₪${amount}`;
  };

  if (!appointment.invoice_url) {
    return null;
  }

  return (
    <div className="bg-gradient-to-br from-green-50 to-emerald-50 border border-green-200 rounded-lg p-4 space-y-3">
      <div className="flex items-center justify-between">
        <h4 className="font-medium text-green-800 flex items-center">
          <svg className="w-5 h-5 ml-2 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          {t.invoiceAvailable}
        </h4>
        <div className="bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full font-medium">
          {t.invoiceReady}
        </div>
      </div>

      {/* Invoice Details */}
      <div className="text-sm text-green-700 space-y-1">
        <div className="flex justify-between">
          <span>סכום:</span>
          <span className="font-medium">{formatInvoiceAmount()}</span>
        </div>
        
        {appointment.invoice_number && (
          <div className="flex justify-between">
            <span>{t.invoiceNumber}:</span>
            <span className="font-medium">{appointment.invoice_number}</span>
          </div>
        )}

        {appointment.payment_completed_at && (
          <div className="flex justify-between">
            <span>תאריך תשלום:</span>
            <span className="font-medium">
              {new Date(appointment.payment_completed_at).toLocaleDateString('he-IL')}
            </span>
          </div>
        )}

        {appointment.payment_method && (
          <div className="flex justify-between">
            <span>אמצעי תשלום:</span>
            <span className="font-medium">{appointment.payment_method}</span>
          </div>
        )}

        {appointment.transaction_id && (
          <div className="flex justify-between">
            <span>מספר עסקה:</span>
            <span className="font-medium text-xs">{appointment.transaction_id}</span>
          </div>
        )}
      </div>

      {/* Download Button */}
      <button
        onClick={handleDownloadInvoice}
        className="w-full bg-gradient-to-r from-green-600 to-emerald-600 text-white py-2.5 px-4 rounded-lg font-medium hover:from-green-700 hover:to-emerald-700 focus:ring-4 focus:ring-green-200 transition-all duration-200 flex items-center justify-center"
      >
        <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
        {t.downloadInvoice}
      </button>

      <p className="text-xs text-green-600 text-center">
        {t.openInvoiceInNewTab}
      </p>
    </div>
  );
};

export default InvoicePanel;